module.exports = __webpack_public_path__ + "static/media/login.aac2a1a6.svg";